export default __webpack_public_path__ + "ch-casino.icon-f1584983fcff04c2654ea5bf6a813984.png";